import React from "react";

const COLORS = ["#ff6a00", "#111827", "#3b82f6", "#10b981", "#f59e0b", "#ef4444"];

const AdminPieChart = ({ title, data = [] }) => {
  const total = data.reduce((s, d) => s + (d.value || 0), 0) || 1;
  let angle = 0;
  const slices = data.map((d, i) => {
    const pct = (d.value / total) * 100;
    const sliceAngle = (d.value / total) * 360;
    const start = angle;
    angle += sliceAngle;
    return { ...d, pct, start, end: angle, color: COLORS[i % COLORS.length] };
  });

  const gradient = slices
    .map((s) => `${s.color} ${s.start}deg ${s.end}deg`)
    .join(", ");

  return (
    <div className="admin-chart-card">
      <h3>{title}</h3>
      <div className="admin-chart-body">
        <div
          className="admin-pie"
          style={{
            background: data.length
              ? `conic-gradient(${gradient})`
              : "#e2e8f0",
          }}
          aria-hidden="true"
        />
        <ul className="admin-chart-legend">
          {data.map((d, i) => (
            <li key={d.name}>
              <span
                className="admin-chart-dot"
                style={{ background: COLORS[i % COLORS.length] }}
              />
              <span>
                {d.name}: <strong>{d.value}</strong> ({((d.value / total) * 100).toFixed(0)}%)
              </span>
            </li>
          ))}
          {!data.length && <li className="admin-empty">No data</li>}
        </ul>
      </div>
    </div>
  );
};

export default AdminPieChart;
